import { render, staticRenderFns } from "./AdditionalInformation.vue?vue&type=template&id=8aaf8680&"
import script from "./AdditionalInformation.vue?vue&type=script&lang=js&"
export * from "./AdditionalInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8aaf8680')) {
      api.createRecord('8aaf8680', component.options)
    } else {
      api.reload('8aaf8680', component.options)
    }
    module.hot.accept("./AdditionalInformation.vue?vue&type=template&id=8aaf8680&", function () {
      api.rerender('8aaf8680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cancel/AdditionalInformation.vue"
export default component.exports